module.exports = __webpack_public_path__ + "static/media/high-shot.eed9def8.svg";